import styled from "styled-components";
import theme from "../theme";

const Card = styled.section`
  background: white;
  box-shadow: ${theme.shadow};
  padding: ${theme.margin}rem;

  + * {
    margin-top: ${theme.margin}rem;
  }
`;

export default Card;
